import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "14",
  viewBox: "0 0 30 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6673 11.0007H7.00065C4.80065 11.0007 3.00065 9.20065 3.00065 7.00065C3.00065 4.80065 4.80065 3.00065 7.00065 3.00065H13.6673V0.333984H7.00065C3.32065 0.333984 0.333984 3.32065 0.333984 7.00065C0.333984 10.6807 3.32065 13.6673 7.00065 13.6673H13.6673V11.0007ZM23.0007 0.333984H16.334V3.00065H23.0007C25.2007 3.00065 27.0007 4.80065 27.0007 7.00065C27.0007 9.20065 25.2007 11.0007 23.0007 11.0007H16.334V13.6673H23.0007C26.6807 13.6673 29.6673 10.6807 29.6673 7.00065C29.6673 3.32065 26.6807 0.333984 23.0007 0.333984ZM21.6673 5.66732H8.33398V8.33399H21.6673V5.66732Z",
      fill: "#152443"
    }, null, -1)
  ]))]))
}
export default { render: render }